import { AutogenLayoutExchangeRateList } from "./autogen/AutogenLayoutExchangeRateList";

export class ExchangeRateList extends AutogenLayoutExchangeRateList {
    onLoad() {
        this.mainDataSource.search({ effective_date: ">=t-60" });
    }
}
